import React from 'react';
import { Box } from '@mui/material';
import { TabPanel } from '../../../ui';
import CatalogFrames from './CatalogFrames';

const Catalog = () => {
    const value = 0;

    return (
        <Box sx={{ width: '100%' }}>
            <TabPanel idfor='CatalogFrames' value={value} index={0}>
                <CatalogFrames />
            </TabPanel>
            {/* Future tabs for lenses, contacts can be added here */}
        </Box>
    );
};

export default Catalog;
